"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagementUrl = exports.SolverUrl = exports.UrlContext = void 0;
var Constants_1 = require("./Constants");
var UrlContext = /** @class */ (function () {
    function UrlContext(url) {
        this.url = url;
    }
    UrlContext.prototype.createUrl = function (data, domain) {
        return this.url.createUrl(data, domain);
    };
    return UrlContext;
}());
exports.UrlContext = UrlContext;
var SolverUrl = /** @class */ (function () {
    function SolverUrl() {
    }
    SolverUrl.prototype.createUrl = function (data, domain) {
        var version;
        if (isNaN(Number(data.version)) && data.version !== 'latest' && data.version !== undefined) {
            throw Error('Version is not a valid integer or "latest"');
        }
        var prefix = "/" + data.mode + "/solve";
        var url;
        if (domain) {
            url = domain.protocol + "://" + domain.domainName + ":" + domain.port + prefix + "/" + data.ruleId;
        }
        else {
            url = Constants_1.baseUrl + prefix;
        }
        if (data.version) {
            if (data.version !== 'latest') {
                url += "/" + Number(data.version);
            }
        }
        return url;
    };
    return SolverUrl;
}());
exports.SolverUrl = SolverUrl;
var ManagementUrl = /** @class */ (function () {
    function ManagementUrl() {
    }
    ManagementUrl.prototype.createUrl = function (data, domain) {
        var prefix = "/api";
        var url;
        if (domain) {
            url = domain.protocol + "://" + domain.domainName + ":" + domain.port + prefix;
        }
        else {
            url = Constants_1.baseUrl + prefix;
        }
        return url;
    };
    return ManagementUrl;
}());
exports.ManagementUrl = ManagementUrl;
